import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React from 'react';

import getPosition from './utils/getPosition';

var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Position);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Position.__proto__ || _Object$getPrototypeOf(Position)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      ref: null
    }, _this.initialMouseCoordinates = undefined, _this.setRef = function (ref) {
      _this.setState({ ref: ref });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Position, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          position = _props.position,
          mouseCoordinates = _props.mouseCoordinates,
          mousePosition = _props.mousePosition,
          target = _props.target;
      var ref = this.state.ref;

      var adjustedPosition = {};
      if (target && ref) {
        if (!this.initialMouseCoordinates) {
          // when we show the tooltip relative to the mouse position, always use
          // the initial mouse coordinates so the tooltip is placed in the same spot.
          this.initialMouseCoordinates = mouseCoordinates;
        }
        adjustedPosition = getPosition({
          position: position,
          target: target,
          tooltip: ref,
          mouseCoordinates: this.initialMouseCoordinates,
          mousePosition: mousePosition
        });
      }
      return this.props.children(this.setRef, adjustedPosition.position || position, adjustedPosition.coordinates || {});
    }
  }]);

  return Position;
}(React.Component);

export default Position;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/tooltip/dist/esm/components/Position.js
// module id = 669
// module chunks = 0